const branches = [
  {
    id: 1,
    name: "Ikeja City Mall",
    title: "icm",
    image:
      "https://1.bp.blogspot.com/-SpnQf8Awm7o/Xs1klm3opWI/AAAAAAAAArI/Ig9gCASPRc4ocloMCEBodBrEMw3cTF5rwCLcBGAsYHQ/s1600/IMG_4107.JPG",
  },
  {
    id: 2,
    name: "Maryland Mall",
    title: "marylandmall",
    image:
      "https://livinspaces.net/wp-content/uploads/2016/07/maryland-mall-23.jpg",
  },
  {
    id: 3,
    name: "Banex Mall",
    title: "banex",
    image:
      "https://silverbirdcinemas.com/wp-content/uploads/2023/10/IMG_0036.jpg",
  },
  {
    id: 4,
    name: "Jara Mall",
    title: "jara",
    image:
      "https://lh5.googleusercontent.com/p/AF1QipPrUawobiEVV903YJaDDLg8GiEgVw70QHbX5w5E",
  },
  {
    id: 5,
    name: "Novare Mall",
    title: "novare",
    image: "https://estateintel.com/assets-ei/2016/08/IMG_9684.jpg",
  },
  {
    id: 6,
    name: "Palms Mall",
    title: "palms",
    image: "https://pbs.twimg.com/media/C0OFO4eXcAA4lUS.jpg",
  },
];

export default branches;
